import { EyeInvisibleOutlined, LockFilled } from "@ant-design/icons";
import Localization from "../../../../localization";
import { GroupApi } from "../../../../apis";
import { useEffect, useState } from "react";
import useViewModel from "../../viewModel";
import { useApi } from "../../../../hooks";
import { Flex } from "antd";
import {
  ContentLoader,
  Checkbox,
  Button,
  List,
  Text,
} from "../../../../components";

export const GroupTypes = [
  { id: 0, title: Localization.general.locked, icon: LockFilled },
  { id: 1, title: Localization.general.locked, icon: LockFilled },
  { id: 2, title: Localization.general.private, icon: EyeInvisibleOutlined },
];

const Groups = ({ onConfirm = () => {}, onCancel = () => {} }) => {
  const { device } = useViewModel();
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const { execute } = useApi();
  const [selectedGroups, setSelectedGroups] = useState(
    device.distribution.groups.map((_) => _.id)
  );

  useEffect(() => {
    getData({ screenLoad: true });
  }, []);

  const getData = async ({ screenLoad = false } = {}) => {
    const groups = await execute(async () => await GroupApi.groups(), {
      setLoading: (state) => screenLoad && setLoading(state),
    });
    setGroups(groups);
  };

  if (loading)
    return (
      <ContentLoader
        skeletons={[{ height: "3.8rem" }, { height: "40rem", top: "3rem" }]}
      />
    );
  return (
    <div>
      <Text
        color="secondary"
        children={Localization.service_edit_collaborators.group_modal_desc}
      />
      <List
        className="m-30-t"
        highlightOnHover={false}
        dataSource={groups}
        renderItem={({ name, type, id, nrOfMembers }) => {
          const { title: typeName } =
            GroupTypes.find((_) => _.id === type) || {};
          const checked = selectedGroups.includes(id);
          return (
            <List.Item
              extra={<Checkbox className="m-5-l" checked={checked} />}
              onClick={() =>
                setSelectedGroups((_) =>
                  !checked ? [..._, id] : _.filter((groupId) => groupId !== id)
                )
              }
              children={
                <List.Item.Meta
                  title={name}
                  description={` ${typeName} ${Localization.general.group.toLowerCase()} • ${nrOfMembers} ${(nrOfMembers ==
                  1
                    ? Localization.general.member
                    : Localization.general.members
                  ).toLowerCase()}`}
                />
              }
            />
          );
        }}
      />
      <Flex className="m-30-t" gap={"1rem"}>
        <Button
          type="primary"
          title={Localization.general.confirm}
          onClick={() =>
            onConfirm(groups.filter((_) => selectedGroups.includes(_.id)))
          }
        />
        <Button title={Localization.general.cancel} onClick={onCancel} />
      </Flex>
    </div>
  );
};

export default Groups;
